/* global globalThis */
import URL from "./apiURL";
import { getValidToken } from "../../utils/getValidToken";

export async function underLyingExportData(payload) {
    const token = await getValidToken();
    try {
        const response = await fetch(URL.underLyingDataExportApi, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const blob = await response.blob();

        const url = globalThis.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "exported_data.xlsx");
        document.body.appendChild(link);
        link.click();

        link.remove();
        globalThis.URL.revokeObjectURL(url);

    } catch (error) {
        console.error("Error fetching data:", error.message);
        throw error;
    }
}